import { FC, useEffect, useState } from "react";
import {
    Box,
    Flex,
    Heading,
    Text,
    Icon,
    useBreakpointValue,
    Button,
} from "@smile2impress/components/relaunch";
import { PlusCircledIcon, MinusCircledIcon } from "@smile2impress/components";

import { ContentFromCms } from "./components/ContentFromCms";
import { UniversalTextElementProps } from "./UniversalTextElement.types";

export const UniversalTextElement: FC<UniversalTextElementProps> = ({
    title,
    text,
    withSeparator = false,
    withExpandableText = false,
    isCmsContent = false,
    extraTitleStyles = {},
    extraTextStyles = {},
    textExpanded,
}) => {
    const isMobile = useBreakpointValue({
        base: true,
        tablet: true,
        desktop: false,
        desktopXL: false,
    });
    const [localTextExpanded, setTextExpanded] = useState(
        typeof textExpanded !== "undefined" ? textExpanded : !isMobile
    );
    const toggleTextExpanded = () => {
        setTextExpanded((prev) => !prev);
    };

    useEffect(() => {
        typeof textExpanded !== "undefined" && setTextExpanded(textExpanded);
    }, [textExpanded]);

    const withSeparatorArr = Array.isArray(withSeparator)
        ? withSeparator
        : [withSeparator];

    const separatorDisplay = withSeparatorArr.map((el) =>
        el ? "block" : "none"
    );

    return (
        <Flex
            direction={["column", "column", "column"]}
            justifyContent="space-between"
            w="100%"
            pb={[0, 0, 0]}
            onClick={toggleTextExpanded}
        >
            <Flex
                direction={"row"}
                justifyContent="space-between"
                alignItems="center"
                gap={0.7}
            >
                <Heading
                    textStyle={"H3"}
                    color={["text.base"]}
                    {...extraTitleStyles}
                >
                    {title}
                </Heading>
                {withExpandableText && isMobile && (
                    <Button variant="ghost" p={0}>
                        <Icon
                            w="28px"
                            h="28px"
                            as={
                                localTextExpanded
                                    ? MinusCircledIcon
                                    : PlusCircledIcon
                            }
                        />
                    </Button>
                )}
            </Flex>

            <Box
                overflow="hidden"
                {...(withExpandableText &&
                    isMobile &&
                    (localTextExpanded
                        ? { maxHeight: "100500px" }
                        : { maxHeight: "0px" }))}
            >
                <Box
                    borderBottom="1px solid"
                    borderColor="base.gunmetal"
                    opacity={0.1}
                    mt={[1, 1, 1]}
                    display={separatorDisplay}
                />
                {text &&
                    (isCmsContent ? (
                        <ContentFromCms content={text} />
                    ) : (
                        <Text
                            mt={1}
                            textStyle={["body"]}
                            color={["text.base", "text.base", "text.base"]}
                            mb={0}
                            dangerouslySetInnerHTML={{ __html: text }}
                            whiteSpace="pre-wrap"
                            {...extraTextStyles}
                        />
                    ))}
            </Box>
        </Flex>
    );
};
